import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

export default class SearchArticles extends Component {

constructor(props)
{
	console.log(props);
	super(props);
	this.handleDelete = this.handleDelete.bind(this);
}

state =
{
		blogsObject: {},
		blogs: []
};

componentDidMount()
{
	this.handleOnLoad();
}

handleOnLoad = () => {

  axios.get(`${global.config.apiServicesUrl}/blogs/?filter[where][createUser][eq]=${this.props.userId}`).then(res => {
  const blogs = res.data;
  console.log(blogs);
  this.setState({ blogs : res.data });
	});
}
handleDelete(event){
	//event.preventDefault();
  axios.delete(`${global.config.apiServicesUrl}/blogs/${event.target.id}`).then(res => {
  	this.handleOnLoad();
  	});
}

render(){

return (


				<div class="m-content">				
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       				<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Gazelle VLM</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<a href="index.html" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</a>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<a href="index.html" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</a>
									</li>
								</ul>
							</div>
							
						<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="index.html" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">
						<div class="m-portlet">
							<br />
							<div class="row">
														<h3 class="col-sm-2 m-widget1__title">
															Posts
														</h3>
													<div class="col-sm-6 m--align-right">
														<input class="form-control input-xlarge col-sm-8" placeholder="Filter" />
													</div>
													<a href="create-article" class="col-sm-2 btn btn-success">Create an Article for Posting</a>&nbsp;&nbsp;
    						</div>
							<br />

	<table class="oux_table table table-striped table-bordered table-hover" id="list" border="1" var="item" rows="20"  value="#{ombCustomerForm.searchResults }">

			<thead>
				<tr>
					<th scope = "col">Topic</th>
					<th scope = "col">Created On</th>
					<th scope = "col">Actions</th>
				</tr>
			</thead>

			<tbody>

				{this.state.blogs.map( ( {blogId, topic, createUser, createDate} ) => {

					return	<tr>

							
							<td><Link  to={{ pathname: "/manage-article", search : `?id=${blogId}` }}>{topic}</Link></td>
							{/*
							<th scope = "col">Id</th>
							<th scope = "col">Created By</th>
							<td><Link  to={{ pathname: "/manage-article", search : `?id=${blogId}` }}>{blogId}</Link></td>
							<td><Link  to={{ pathname: "/manage-article", search : `?id=${blogId}` }}>{createUser}</Link></td>
							*/}
							<td><Link  to={{ pathname: "/manage-article", search : `?id=${blogId}` }}>{String(createDate).substring(0,16).replace('T', ' ')}</Link></td>
							<td>

										<button class="btn btn-danger btn-sm" id={blogId} onClick={this.handleDelete}>Delete</button>
							</td>
						</tr>


				})
			}

			</tbody>


		</table>
												</div>
					</div>

	            </div>	
            </div>
            
			</div>
			</div>
			



);
}
}

